module.exports = __webpack_public_path__ + "assets/img/ph_project.b298320a.svg";